module.exports = __webpack_public_path__ + "static/media/memoji-vick.dd4863d9.png";